<ng-container *ngTemplateOutlet="grid; context: { items: items }"/>

<ng-template #grid let-items="items">
  <div class="item-grid">
    <!-- Must track by $index because items could contain duplicate records. -->
    @for (item of items; track $index) {
      <rn-grid-item [catalogRecord]="item"/>
    }
  </div>
</ng-template>
